import { render, staticRenderFns } from "./video-ptz.vue?vue&type=template&id=a313aeb8&scoped=true&"
import script from "./video-ptz.vue?vue&type=script&lang=js&"
export * from "./video-ptz.vue?vue&type=script&lang=js&"
import style0 from "./video-ptz.vue?vue&type=style&index=0&id=a313aeb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a313aeb8",
  null
  
)

export default component.exports